import { SVGProps } from 'react';

const Vercel = ({
  isDark = false,
  props,
}: {
  isDark?: boolean;
  props?: SVGProps<SVGSVGElement>;
  size?: string | number;
}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="62" height="54" viewBox="0 0 62 54" fill="none" {...props}>
    <path fill={isDark ? '#fff' : '#1F1F1F'} fillRule="evenodd" d="M62 54 31 0 0 54h62Z" clipRule="evenodd" />
  </svg>
);

export default Vercel;
